export class HelpersUtil {
  public static calcularDiferencaEmDias(dataInicial: Date, dataFinal: Date): number {
    const diferencaEmMilissegundos = dataFinal.getTime() - dataInicial.getTime();
    const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

    return Math.floor(diferencaEmDias);
  }

  public static calcularDiferencaEmHoras(dataInicial: Date, dataFinal: Date): number {
    const diferencaEmMilissegundos = dataFinal.getTime() - dataInicial.getTime();
    const diferencaEmHoras = diferencaEmMilissegundos / (1000 * 60 * 60);

    return Math.floor(diferencaEmHoras);
  }

  public static decode(encodedData: string): any {
    const jsonData = atob(encodedData);
    return JSON.parse(jsonData);
  }

  public static encode(data: any): string {
    const jsonData = JSON.stringify(data);
    return btoa(jsonData);
  }

  /**
   * 
   * @param callback método a ser executado
   * @param delayInMilliseconds recebe o valor 500 por padrão
   */
  public static executeAfterDelay(callback: () => void, delayInMilliseconds: number = 500): void {
    setTimeout(callback, delayInMilliseconds);
  }

  /**
   * 
   * @param items Array de itens a serem filtrados
   * @param searchText Valor digitado para fazer o filtro
   * @returns O array "items" filtrado baseado no searchText
   */
  public static filterAllFields<T>(items: T[], searchText: string): T[] {
    if (!items) return [];
    if (!searchText) return items;

    searchText = this.prepareValue(searchText);

    return items.filter(it => {
      return Object.values(it).some(value => {
        return this.prepareValue(value.toString()).includes(searchText);
      });
    });
  }

  public static formatarTempoDecorrido(data: Date | string) {
    const agora = new Date();
    const diferenca = agora.getTime() - new Date(data).getTime();

    const minutos = Math.floor(diferenca / (1000 * 60)) % 60;
    const horas = Math.floor(diferenca / (1000 * 60 * 60));

    return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
  }

  public static getPercentageValue(percentage: number, value: number): number {
    return (percentage / 100) * value;
  }

  public static moveObjectToPosition<T>(array: T[], object: T, newPosition: number): T[] {
    if (newPosition < 0 || newPosition >= array.length) {
      return array;
    }

    const currentIndex = array.indexOf(object);
    if (currentIndex === -1) {
      return array;
    }

    const newArray = [...array];
    newArray.splice(currentIndex, 1);
    newArray.splice(newPosition, 0, object);
    return newArray;
  }

  public static prepareValue(str: string | null): string {
    return (str ?? '')
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toUpperCase();
  }

  public static selectNextItem(selectedItemIndex: number, itemCount: number): number {
    if (selectedItemIndex < itemCount - 1) {
      return selectedItemIndex + 1;
    }
    return selectedItemIndex;
  }

  public static selectPreviousItem(selectedItemIndex: number): number {
    if (selectedItemIndex > 0) {
      return selectedItemIndex - 1;
    }
    return selectedItemIndex;
  }

  public static sortList<T>(list: T[], field: string, ascending: boolean): T[] {
    return list.sort((a: any, b: any) => {
      const valueA = a[field].trim().toString().toUpperCase();
      const valueB = b[field].trim().toString().toUpperCase();
      const comparison = valueA.localeCompare(valueB);

      return ascending ? comparison : -comparison;
    });
  }

  public static sumArray(arr: Array<any>, field: string = 'totalItem'): number {
    return arr.map(l => l[field]).reduce((partialSum, a) => partialSum + a, 0);
  }

  public static CopyObject(origem: any, destino: any) {
    for (const chave in origem) {
      if (Object.prototype.hasOwnProperty.call(origem, chave) && destino.hasOwnProperty(chave)) {
          destino[chave] = origem[chave];
      }
  }

    return destino;
}
}
